import { BottomSheetModal } from '@gorhom/bottom-sheet'
import React from 'react'
import { BottomModalContent } from '../../components/ANewDesign/BottomModalContent'
import { observer } from 'mobx-react-lite'
import { Platform, StyleSheet } from 'react-native'
import { FromScreen } from '../../models/game/game-sheets'
import { ReduceMotion } from 'react-native-reanimated'
import { useGameBottomModal } from '../new-design/hooks/useGameBottomModals'
import { DS } from '../../design-system'
import { useMaxWidth } from '../../components/WebWrapper'

const isWeb = Platform.OS === 'web'

export const DeleteBottomSheetModal = observer(() => {
  const maxWidth = useMaxWidth()
  const {
    bottomModalContent,
    bottomSheetModalRef,
    snapPoints,
    closeBottomModal,
    //
    renderBackdrop
  } = useGameBottomModal()

  return (
    <BottomSheetModal
      overrideReduceMotion={ReduceMotion.System}
      ref={bottomSheetModalRef}
      index={0}
      snapPoints={snapPoints}
      enableDynamicSizing={false}
      backdropComponent={renderBackdrop}
      onDismiss={closeBottomModal}
      overDragResistanceFactor={3}
      detached={false}
      enableContentPanningGesture={false}
      enableHandlePanningGesture={true}
      handleStyle={styles.bottomSheetHandleStyle}
      handleIndicatorStyle={styles.bottomSheetIndicatorStyle}
      keyboardBehavior="interactive"
      keyboardBlurBehavior="none"
      name="delete-sheet"
      backgroundStyle={{ backgroundColor: DS.palette['Brand/Cream'] }}
      style={{
        marginHorizontal: isWeb ? 'auto' : undefined,
        maxWidth: maxWidth,
        width: '100%'
      }}
    >
      <BottomModalContent config={bottomModalContent} />
    </BottomSheetModal>
  )
})

const styles = StyleSheet.create({
  bottomSheetHandleStyle: {
    backgroundColor: '#F6F2E9',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingBottom: 0,
    height: 32
  },
  bottomSheetIndicatorStyle: {
    backgroundColor: 'gray',
    height: 2,
    width: 44
  }
})
